
import { Navigate } from "react-router-dom";

const PremiumPaymentPage = () => {
  return <Navigate to="/pricing?checkout=premium_tier" replace />;
};

export default PremiumPaymentPage;
